// Constants for tutorial tooltip configuration

export const TOP_RIGHT_STEPS = ['review_note_page', 'transcript_page', 'note_citations', 'patient_visit_summary_page'];

// Steps whose page modal moves aside so the card can sit next to it. The
// telehealth slides are deliberately absent: they anchor their card beside the
// Telehealth Audio Setup window, which stays centred exactly where the user
// sees it outside the tour.
export const MODAL_NUDGE_STEPS = new Set([
  'precharting_overview',
  'precharting_custom_instructions',
  'precharting_custom_prompt',
  'precharting_optional_outline',
  'precharting_conversation_updates',
]);

// Tab targets, highlighted by name because the step's targetSelector never
// names them.
export const TAB_ARIA_LABEL_BY_STEP = {
  review_note_page: 'Note tab',
  transcript_page: 'Transcript tab',
  note_citations: 'Note citations tab',
  patient_visit_summary_page: 'Patient visit summary tab',
};

// Steps whose dim is decoration only. The backdrop sits above every page
// element (z-index 10000 against the Smart Chart window's 50), so leaving it
// hit-testable would swallow the clicks the slide is asking the user to make.
export const NON_BLOCKING_BACKDROP_STEPS = [
  'precharting_overview',
  ...Object.keys(TAB_ARIA_LABEL_BY_STEP),
  'leave_feedback',
  'save_upload_note',
  'manage_dot_phrase',
  // Asks the user to press Change site, and points at a control inside the
  // window that opens — both would be swallowed by a hit-testable backdrop.
  'change_point_of_care',
  'select_launch_site',
];

// Steps whose highlighted element sits inside a stacking context it cannot be
// lifted out of — the note modal, the settings tab row — so it can never rise
// above the backdrop the way other targets do. These dim through the spotlight
// cut-out alone, leaving the backdrop itself clear so the cut-out really is
// untinted.
export const SPOTLIGHT_ONLY_DIM_STEPS = [
  ...Object.keys(TAB_ARIA_LABEL_BY_STEP),
  'leave_feedback',
  'save_upload_note',
  'manage_dot_phrase',
  // The Launch from list sits inside the Select launch site window, which the
  // highlight cannot be lifted out of.
  'select_launch_site',
];

export const TOOLTIP_DIMENSIONS = {
  WIDTH: 400,
  HEIGHT: 300,
  OFFSET: 15,
  TOP_OFFSET_REM: 5,
  TOP_OFFSET_PX: 5 * 16, // Convert rem to px
};

export const POSITIONING = {
  SPOTLIGHT_PADDING: 8,
  UPDATE_INTERVAL: 100, // ms
  SCROLL_DELAY: 300, // ms for tab switches
  ACTION_DELAY: 100, // ms for auto-actions
  FEEDBACK_CLICK_DELAY: 100, // ms for feedback button click
};

export const BACKDROP_OPACITY = {
  DEFAULT: 'bg-black/40',
  SCHEDULE_REFRESH: 'bg-black/30',
};

export const SPOTLIGHT_STYLES = {
  DEFAULT_BOX_SHADOW: '0 0 0 9999px rgba(0, 0, 0, 0.4)',
  SCHEDULE_REFRESH_BOX_SHADOW: '0 0 0 9999px rgba(0, 0, 0, 0.3)',
  SCHEDULE_REFRESH_BG: 'bg-white',
  DEFAULT_BG: 'bg-transparent',
};

export const STEP_IDS = {
  LEAVE_FEEDBACK: 'leave_feedback',
  VETERAN_CONSENT: 'veteran_consent',
  WELCOME_MODAL: 'welcome_modal',
  SCHEDULE_REFRESH: 'schedule_refresh',
};

export const SECTION_IDS = {
  REVIEW_UPLOAD: 'review_upload',
};
